import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

interface UseNotifyNotificationReturn {
  notifyNotification: (_variables: Record<string, any>) => void;
  notifying: boolean;
}

/**
 * Custom hook to mark a notification as notified (isNotify = true).
 * @param {Function} [onCompleted] - Callback function called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function called when an error occurs.
 */
export function useNotifyNotification(
  onCompleted: (_data: any) => void = () => {},
  onError: (_err: any) => void = () => {},
): UseNotifyNotificationReturn {
  const [notifyNotification, { loading }] = useMutation<any>(
    mutations.notifyNotification,
    {
      onCompleted: (_data) => {
        onCompleted(_data);
      },
      onError: (_err) => {
        onError(_err);
      },
    },
  );

  const notifyNotificationRow = useCallback(
    (_variables: Record<string, any>) => {
      notifyNotification({
        variables: _variables,
      }).then();
    },
    [notifyNotification],
  );

  return {
    notifyNotification: notifyNotificationRow,
    notifying: loading,
  };
}
